import SimpleImage from '../SimpleImage/SimpleImage';
import "./DisplayCase.css";

export default function DisplayCase({ exhibit }) {
	const caseRivets = ["tl", "tr", "bl", "br"];
	const plaqueRivets = ["tl", "tr", "bl", "br"];

	return (
		<div className="display-case-slide">
			<div className="display-case-shell">
				<div className="display-case-frame">
					<div className="display-case-wood-grain" />
					{caseRivets.map((pos) => (
						<div key={`${exhibit.title}-${pos}`} className={`display-case-rivet display-case-rivet--${pos}`} />
					))}
					<div className="display-case-image-frame">
						<SimpleImage src={exhibit.image} alt={exhibit.title} width={"1px"} height={"1px"} style={{ width: "100%", height: "100%" }} />
						<div className="display-case-glare" />
						<div className="display-case-shadow" />
					</div>
				</div>
				<div className="display-case-plaque mdc-slide-enter">
					{plaqueRivets.map((pos) => (
						<div key={`${exhibit.title}-plaque-${pos}`} className={`display-case-plaque-rivet display-case-plaque-rivet--${pos}`} />
					))}
					<h2 className="display-case-title">{exhibit.title}</h2>
					<div className="display-case-origin">{exhibit.origin}</div>
					<div className="display-case-divider" />
					<p className="display-case-description">{exhibit.description}</p>
				</div>
			</div>
		</div>
	);
}
